export default {
    name: 'app',
    data() {
        return {
            menu: false
        }
    }
}
